export const getAppAbilitiesList = (state) => state.permissions.appAbilitiesList
